var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-window", {
    attrs: { value: _vm.dialogProps },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("perfil", {
              attrs: { usuario: _vm.usuario, "perfil-proprio": false },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }